module.exports = __webpack_public_path__ + "img/M0021.eab937dc.png";